module.exports = __webpack_public_path__ + "img/03.34efbc1a.jpeg";